export default __webpack_public_path__ + "static/media/darkburden.6cbcaec8.png";